/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { ActualPageService } from '@pages/ActualPage/services';

const getSrv = () => {
  return vappContainer.get<ActualPageService>(ActualPageService.displayName);
};

export const actualPolicy = async (context: any, event: any) => {
  const currentState = 'GET_ACTUAL_POLICY';
  const method = 'actualPolicy';
  const _getArgs = () => {
    let _args: any = {};
    if (event?.type === 'START') {
      _args = context['GET_ACTUAL_POLICY'];
    }
    if (event?.type === 'TRIGGER_REFRESH') {
      _args = {
        offset: event?.offset,
        size: event?.size,
        where: event?.where ?? [],
      };
    }
    console.log('getPageContent args =>', _args);
    return _args;
  };
  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getActualListSync(_getArgs());
      if (shelves) {
        return resolve({
          key: 'RENDER_ACTUAL_POLICY',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_ACTUAL_POLICY_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_ACTUAL_POLICY_ERROR',
        value: err?.message,
      });
    }
  });
};
